export const neutral = {
  white: "#ffffff",
  black: "#000000",
  50: "rgba(250, 250, 250, 1)",
  100: "rgba(245, 245, 245, 1)",
  200: "rgba(229, 229, 229, 1)",
  300: "rgba(212, 212, 212, 1)",
  400: "rgba(161, 161, 161, 1)",
  500: "rgba(115, 115, 115, 1)",
  600: "rgba(82, 82, 82, 1)",
  700: "rgba(64, 64, 64, 1)",
  800: "rgba(38, 38, 38, 1)",
  900: "rgba(23, 23, 23, 1)",
  950: "rgba(10, 10, 10, 1)",
}
export const red = {
  50: "rgba(254, 242, 242, 1)",
  100: "rgba(255, 226, 226, 1)",
  200: "rgba(255, 201, 201, 1)",
  300: "rgba(255, 162, 162, 1)",
  400: "rgba(255, 100, 103, 1)",
  500: "rgba(251, 44, 54, 1)",
  600: "rgba(231, 0, 11, 1)",
  700: "rgba(193, 0, 7, 1)",
  800: "rgba(159, 7, 18, 1)",
  900: "rgba(130, 24, 26, 1)",
  950: "rgba(70, 8, 9, 1)",
}
export const orange = {
  50: "rgba(255, 247, 237, 1)",
  100: "rgba(255, 237, 212, 1)",
  200: "rgba(255, 214, 168, 1)",
  300: "rgba(255, 184, 106, 1)",
  400: "rgba(255, 137, 4, 1)",
  500: "rgba(255, 105, 0, 1)",
  600: "rgba(245, 73, 0, 1)",
  700: "rgba(202, 53, 0, 1)",
  800: "rgba(159, 45, 0, 1)",
  900: "rgba(126, 42, 12, 1)",
  950: "rgba(68, 19, 6, 1)",
}
export const amber = {
  50: "rgba(255, 251, 235, 1)",
  100: "rgba(254, 243, 198, 1)",
  200: "rgba(254, 230, 133, 1)",
  300: "rgba(255, 210, 48, 1)",
  400: "rgba(255, 185, 0, 1)",
  500: "rgba(254, 154, 0, 1)",
  600: "rgba(225, 113, 0, 1)",
  700: "rgba(187, 77, 0, 1)",
  800: "rgba(151, 60, 0, 1)",
  900: "rgba(123, 51, 6, 1)",
  950: "rgba(70, 25, 1, 1)",
}
export const yellow = {
  50: "rgba(254, 252, 232, 1)",
  100: "rgba(254, 249, 194, 1)",
  200: "rgba(255, 240, 133, 1)",
  300: "rgba(255, 223, 32, 1)",
  400: "rgba(253, 199, 0, 1)",
  500: "rgba(240, 177, 0, 1)",
  600: "rgba(208, 135, 0, 1)",
  700: "rgba(166, 95, 0, 1)",
  800: "rgba(137, 75, 0, 1)",
  900: "rgba(115, 62, 10, 1)",
  950: "rgba(67, 32, 4, 1)",
}
export const lime = {
  50: "rgba(247, 254, 231, 1)",
  100: "rgba(236, 252, 202, 1)",
  200: "rgba(216, 249, 153, 1)",
  300: "rgba(187, 244, 81, 1)",
  400: "rgba(154, 230, 0, 1)",
  500: "rgba(124, 207, 0, 1)",
  600: "rgba(94, 165, 0, 1)",
  700: "rgba(73, 125, 0, 1)",
  800: "rgba(60, 99, 0, 1)",
  900: "rgba(53, 83, 14, 1)",
  950: "rgba(25, 46, 3, 1)",
}
export const green = {
  50: "rgba(240, 253, 244, 1)",
  100: "rgba(220, 252, 231, 1)",
  200: "rgba(185, 248, 207, 1)",
  300: "rgba(123, 241, 168, 1)",
  400: "rgba(5, 223, 114, 1)",
  500: "rgba(0, 201, 80, 1)",
  600: "rgba(0, 166, 62, 1)",
  700: "rgba(0, 130, 54, 1)",
  800: "rgba(1, 102, 48, 1)",
  900: "rgba(13, 84, 43, 1)",
  950: "rgba(3, 46, 21, 1)",
}
export const emerald = {
  50: "rgba(236, 253, 245, 1)",
  100: "rgba(208, 250, 229, 1)",
  200: "rgba(164, 244, 207, 1)",
  300: "rgba(94, 233, 181, 1)",
  400: "rgba(0, 212, 146, 1)",
  500: "rgba(0, 188, 125, 1)",
  600: "rgba(0, 153, 102, 1)",
  700: "rgba(0, 122, 85, 1)",
  800: "rgba(0, 96, 69, 1)",
  900: "rgba(0, 79, 59, 1)",
  950: "rgba(0, 44, 34, 1)",
}
export const teal = {
  50: "rgba(240, 253, 250, 1)",
  100: "rgba(203, 251, 241, 1)",
  200: "rgba(150, 247, 228, 1)",
  300: "rgba(70, 236, 213, 1)",
  400: "rgba(0, 213, 190, 1)",
  500: "rgba(0, 187, 167, 1)",
  600: "rgba(0, 150, 137, 1)",
  700: "rgba(0, 120, 111, 1)",
  800: "rgba(0, 95, 90, 1)",
  900: "rgba(11, 79, 74, 1)",
  950: "rgba(2, 47, 46, 1)",
}
export const cyan = {
  50: "rgba(236, 254, 255, 1)",
  100: "rgba(206, 250, 254, 1)",
  200: "rgba(162, 244, 253, 1)",
  300: "rgba(83, 234, 253, 1)",
  400: "rgba(0, 211, 243, 1)",
  500: "rgba(0, 184, 219, 1)",
  600: "rgba(0, 146, 184, 1)",
  700: "rgba(0, 117, 149, 1)",
  800: "rgba(0, 95, 120, 1)",
  900: "rgba(16, 78, 100, 1)",
  950: "rgba(5, 51, 69, 1)",
}
export const sky = {
  50: "rgba(240, 249, 255, 1)",
  100: "rgba(223, 242, 254, 1)",
  200: "rgba(184, 230, 254, 1)",
  300: "rgba(116, 212, 255, 1)",
  400: "rgba(0, 188, 255, 1)",
  500: "rgba(0, 166, 244, 1)",
  600: "rgba(0, 132, 209, 1)",
  700: "rgba(0, 105, 168, 1)",
  800: "rgba(0, 89, 138, 1)",
  900: "rgba(2, 74, 112, 1)",
  950: "rgba(5, 47, 74, 1)",
}
export const blue = {
  50: "rgba(239, 246, 255, 1)",
  100: "rgba(219, 234, 254, 1)",
  200: "rgba(190, 219, 255, 1)",
  300: "rgba(142, 197, 255, 1)",
  400: "rgba(81, 162, 255, 1)",
  500: "rgba(43, 127, 255, 1)",
  600: "rgba(21, 93, 252, 1)",
  700: "rgba(20, 71, 230, 1)",
  800: "rgba(25, 60, 184, 1)",
  900: "rgba(28, 57, 142, 1)",
  950: "rgba(22, 36, 86, 1)",
}
export const indigo = {
  50: "rgba(238, 242, 255, 1)",
  100: "rgba(224, 231, 255, 1)",
  200: "rgba(198, 210, 255, 1)",
  300: "rgba(163, 179, 255, 1)",
  400: "rgba(124, 134, 255, 1)",
  500: "rgba(97, 95, 255, 1)",
  600: "rgba(79, 57, 246, 1)",
  700: "rgba(67, 45, 215, 1)",
  800: "rgba(55, 42, 172, 1)",
  900: "rgba(49, 44, 133, 1)",
  950: "rgba(30, 26, 77, 1)",
}
export const violet = {
  50: "rgba(245, 243, 255, 1)",
  100: "rgba(237, 233, 254, 1)",
  200: "rgba(221, 214, 255, 1)",
  300: "rgba(196, 180, 255, 1)",
  400: "rgba(166, 132, 255, 1)",
  500: "rgba(142, 81, 255, 1)",
  600: "rgba(127, 34, 254, 1)",
  700: "rgba(112, 8, 231, 1)",
  800: "rgba(93, 14, 192, 1)",
  900: "rgba(77, 23, 154, 1)",
  950: "rgba(47, 13, 104, 1)",
}
export const purple = {
  50: "rgba(250, 245, 255, 1)",
  100: "rgba(243, 232, 255, 1)",
  200: "rgba(233, 212, 255, 1)",
  300: "rgba(218, 178, 255, 1)",
  400: "rgba(194, 122, 255, 1)",
  500: "rgba(173, 70, 255, 1)",
  600: "rgba(152, 16, 250, 1)",
  700: "rgba(130, 0, 219, 1)",
  800: "rgba(110, 17, 176, 1)",
  900: "rgba(89, 22, 139, 1)",
  950: "rgba(60, 3, 102, 1)",
}
export const fuchsia = {
  50: "rgba(253, 244, 255, 1)",
  100: "rgba(250, 232, 255, 1)",
  200: "rgba(246, 207, 255, 1)",
  300: "rgba(244, 168, 255, 1)",
  400: "rgba(237, 106, 255, 1)",
  500: "rgba(225, 42, 251, 1)",
  600: "rgba(200, 0, 222, 1)",
  700: "rgba(168, 0, 183, 1)",
  800: "rgba(138, 1, 148, 1)",
  900: "rgba(114, 19, 120, 1)",
  950: "rgba(75, 0, 79, 1)",
}
export const pink = {
  50: "rgba(253, 242, 248, 1)",
  100: "rgba(252, 231, 243, 1)",
  200: "rgba(252, 206, 232, 1)",
  300: "rgba(253, 165, 213, 1)",
  400: "rgba(251, 100, 182, 1)",
  500: "rgba(246, 51, 154, 1)",
  600: "rgba(230, 0, 118, 1)",
  700: "rgba(198, 0, 92, 1)",
  800: "rgba(163, 0, 76, 1)",
  900: "rgba(134, 16, 67, 1)",
  950: "rgba(81, 4, 36, 1)",
}
export const rose = {
  50: "rgba(255, 241, 242, 1)",
  100: "rgba(255, 228, 230, 1)",
  200: "rgba(255, 204, 211, 1)",
  300: "rgba(255, 161, 173, 1)",
  400: "rgba(255, 99, 126, 1)",
  500: "rgba(255, 32, 86, 1)",
  600: "rgba(236, 0, 63, 1)",
  700: "rgba(199, 0, 54, 1)",
  800: "rgba(165, 0, 54, 1)",
  900: "rgba(139, 8, 54, 1)",
  950: "rgba(77, 2, 24, 1)",
}

export const getColorForValueSign = (
  value: number | string | null | undefined,
): string | null => {
  if (value === null || value === undefined) {
    return null
  }

  const numericValue = typeof value === "string" ? parseInt(value, 10) : value
  return numericValue < 0 ? red[800] : null
}
